import type { Package } from '@/useDelivery';
import type { Area } from '@/useDeliveryAreaCode';

export const sumProductPrice = (value: number, element: Package, currentIndex: number) => {
  const data = value + parseInt(element?.price as any, 10);
  return data;
};

export function sumDeliveryFee(value: string, element: Package, currentIndex: number): number {
  return parseFloat(value + parseFloat(element.deliveryFee as any));
}

export function getAreaDeliveryFee(item: Package, area: Area | null = null) {
  let areaDeliveryFee = item.product.areaPriceByProduct.filter((element: any) => element.area.id === area);
  if (areaDeliveryFee.length > 0) areaDeliveryFee = areaDeliveryFee[0].price;
  else areaDeliveryFee = 0;
  let areaDeliveryFeeByWeight = item.product.areaPriceByWeight.filter((element: any) => element.area.id === area);
  if (areaDeliveryFeeByWeight.length > 0) areaDeliveryFeeByWeight = areaDeliveryFeeByWeight[0].price;
  else areaDeliveryFeeByWeight = 0;
  let areaDeliveryFeeByVolume = item.product.areaPriceByVolume.filter((element: any) => element.area.id === area);
  if (areaDeliveryFeeByVolume.length > 0) areaDeliveryFeeByVolume = areaDeliveryFeeByVolume[0].price;
  else areaDeliveryFeeByVolume = 0;

  return {
    areaDeliveryFee,
    areaDeliveryFeeByWeight,
    areaDeliveryFeeByVolume,
  };
}

export function formatPackage(item: Package, area: Area | null = null) {
  const {
    areaDeliveryFee,
    areaDeliveryFeeByWeight,
    areaDeliveryFeeByVolume,
  } = getAreaDeliveryFee(item, area);
  return {
    id: item.id,
    product: item.product,
    name: item.name,
    code: item.code,
    width: item.width,
    length: item.length,
    height: item.height,
    count: item.count || item.quantity,
    weight: item.weight,
    unit: item.unit,
    deliveryFee: item.deliveryFee || item.estimateTotalDeliveryFee,
    deliveryFeePerUnit: (item.deliveryFee / (item.count || (item.quantity || 1))) || 0,
    itemGroup: item.product?.productGroup || undefined,
    areaDeliveryFee,
    areaDeliveryFeeByWeight,
    areaDeliveryFeeByVolume,
    price: item.price,
  };
}

export default function useCreateDelivery() {
  return {};
}
